export const NGLTowerTargetsConst = {
    Target_Value: 'TargetValue',
    Min_Value:'MinValue',
    Max_Value:'MaxValue',
    NGLTowerTargets:'NGLTowerTargets',
    NGLTeamsTowerTargets:'NGLTeams.TowerTargets',
    NGLTeamsTowerTargetParam:'NGLTeams.TowerTargetParam'
  };

  export const Units = ["Vol%","psia"];